export default __webpack_public_path__ + "static/media/mcPeg.74ad9b49.jpg";